import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyBycLwOWdDydRKGSmMpwtGXRJcuRbIAiCU",
  authDomain: "bauheld-d4adb.firebaseapp.com",
  projectId: "bauheld-d4adb",
  storageBucket: "bauheld-d4adb.firebasestorage.app",
  messagingSenderId: "481706267605",
  appId: "1:481706267605:web:62b88336092c867e82235c",
  measurementId: "G-CF6KD2CN76"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const storage = getStorage(app);

export default app;